var map = {
	"./ar/menu.json": 60562,
	"./cs/menu.json": 88321,
	"./cy/menu.json": 12270,
	"./da/menu.json": 95545,
	"./de/menu.json": 86565,
	"./en/menu.json": 99800,
	"./es/menu.json": 55617,
	"./fi/menu.json": 39864,
	"./fr/menu.json": 45401,
	"./he/menu.json": 61988,
	"./hi/menu.json": 29479,
	"./hr/menu.json": 10281,
	"./hu/menu.json": 54121,
	"./it/menu.json": 22349,
	"./ja/menu.json": 32435,
	"./kk/menu.json": 69782,
	"./kn/menu.json": 67736,
	"./ko/menu.json": 32502,
	"./ml/menu.json": 40080,
	"./mr/menu.json": 46794,
	"./nl/menu.json": 68609,
	"./pl/menu.json": 17359,
	"./pt/menu.json": 84404,
	"./ro/menu.json": 37756,
	"./ru/menu.json": 49343,
	"./sh/menu.json": 23818,
	"./sk/menu.json": 26508,
	"./sr/menu.json": 50701,
	"./sv/menu.json": 31730,
	"./ta/menu.json": 88021,
	"./te/menu.json": 68638,
	"./vi/menu.json": 70445
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22662;